import { colors } from '@material-ui/core'

const white = '#FFFFFF'
const black = '#000000'

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#1E2FA9',
    main: '#1E2FA9',
    light: '#2A3ECB',
    smooth: '#364AD3',
    300: '#495BD4'
    // main: '#702CB9',
    // #1e5fa9
  },
  secondary: {
    contrastText: white,
    dark: '#DC9D09',
    main: '#E7A60D',
    light: '#F0BC42'
    // dark: colors.blue[900],
    // main: colors.blue.A400,
    // light: colors.blue.A400
  },
  success: {
    contrastText: white,
    dark: '#27ae60',
    main: '#2ecc71',
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  background: {
    default: '#F4F6F8',
    paper: white
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200]
}
